/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
*/

import {NodeType} from 'prosemirror-model';
import {EditorState, Transaction} from 'prosemirror-state';
import {Command, lift, wrapIn} from 'prosemirror-commands';
import {isNodeActive} from '../../../helpers';

class Blockqote {
    /**
     * Toggle command.
     * 
     * @returns Command.
     */
    toggle(): Command {
        return (state: EditorState, dispatch?: (tr: Transaction) => void): boolean => {
            const {schema} = state;

            const type: NodeType = schema.nodes.blockquote;
            if (!type) {
                return false;
            }

            if (this.isActive(state)) {
                return lift(state, dispatch);
            }

            return wrapIn(type)(state, dispatch);
        };
    }

    /**
     * Does command active.
     * 
     * @param state EditorState.
     * @returns Boolean.
     */
    isActive(state: EditorState): boolean {
        const {schema} = state;

        const type: NodeType = schema.nodes.blockquote;
        if (!type) {
            return false;
        }

        return isNodeActive(state, type);
    }

    /**
     * Does command can execute.
     * 
     * @param state EditorState.
     * @returns Boolean.
     */
    canExecute(state: EditorState): boolean {
        return this.toggle()(state);
    }
}

export default Blockqote;
